import styled from "styled-components";
import Switch from "react-switch";

export const SwitchStyled = styled(Switch).attrs(
  (props: { checked: boolean; disabled?: boolean; offColor?: string }) => ({
    onColor: "#0063F9",
    onHandleColor: "#ffffff",
    handleDiameter: 20,
    uncheckedIcon: false,
    checkedIcon: false,
    height: 18,
    width: 32,
    offColor: props.offColor ?? (props.checked ? "#0063F9" : "#323232"),
  }),
)`
  .react-switch-handle,
  .react-switch-bg {
    cursor: ${(props) =>
      props.disabled ? "not-allowed" : "pointer"} !important;
  }
`;
